<template>
	<div>
		<LayoutConfiguracao>
			<h1 class="text-H5 mb-4 mt-10">
				{{ i18n.t('configInventarioFlorestal') }}
			</h1>
			<div class="flex flex-col gap-4">
				<div>
					<span class="flex gap-1 items-center">
						<label class="text-label"> {{ i18n.t('tipoDeMedicao') }} *</label>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">
									{{ i18n.t('tipoDeMedicao') }}
								</p>
								<p class="text-s">
									{{ i18n.t('tipoDeMedicaoHelp') }}
								</p>
							</div>
						</Tooltip>
					</span>
					<Radio
						v-model="inventario.config_app_tx_mdco_tpmd"
						:label="`${i18n.t('diametro')} (${i18n.t('hbd')})`"
						name="tipo-medicao"
						model-value="DAP"
					/>
					<Radio
						v-model="inventario.config_app_tx_mdco_tpmd"
						:label="`${i18n.t('circunferencia')} (${i18n.t('hbc')})`"
						name="tipo-medicao"
						model-value="CAP"
					/>
				</div>
				<div>
					<span class="flex gap-1 items-center">
						<label class="text-label">{{ i18n.t('contagemDoNumeroDeArvores') }} *</label>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">{{ i18n.t('contagemDoNumeroDeArvores') }}</p>
								<p class="text-s">{{ i18n.t('contagemNumeroDeArvoresHelp') }}</p>
							</div>
						</Tooltip>
					</span>
					<Radio
						v-model="inventario.config_app_yn_mdco_arvs_count"
						:label="i18n.t('contagemNumeroDearvores')"
						name="numero-arvores"
						:model-value="true"
					/>
					<Radio
						v-model="inventario.config_app_yn_mdco_arvs_count"
						:label="i18n.t('followContinuousCount')"
						name="numero-arvores"
						:model-value="false"
					/>
				</div>
				<div>
					<span class="flex gap-1 items-center">
						<label class="text-label">{{ i18n.t('numeroCasasDecimais') }} *</label>
						<Tooltip :options="{ placement: 'top' }">
							<template #trigger>
								<Icon
									icon="octicon:question-16"
									class="text-gray-medium text-sm"
								/>
							</template>
							<div class="flex flex-col gap-2 max-w-xs p-2">
								<p class="text-s-bold">{{ i18n.t('numeroCasasDecimais') }}</p>
								<p class="text-s">{{ i18n.t('numeroCasasDecimaisHelp') }}</p>
							</div>
						</Tooltip>
					</span>
					<Radio
						v-model="inventario.config_app_nr_mdco_nrcd"
						label="1"
						name="casas-decimais"
						:model-value="1"
					/>
					<Radio
						v-model="inventario.config_app_nr_mdco_nrcd"
						label="2"
						name="casas-decimais"
						:model-value="2"
					/>
				</div>
				<div>
					<label class="text-label">{{ i18n.t('avaliacaoIntensidade') }} *</label>
					<Radio
						v-model="inventario.config_app_tx_tipo_intensidade"
						:label="i18n.t('continua')"
						name="avaliacao-intensidade"
						:model-value="0"
					/>
					<Radio
						v-model="inventario.config_app_tx_tipo_intensidade"
						:label="i18n.t('categorizada')"
						name="avaliacao-intensidade"
						:model-value="1"
					/>
				</div>
				<div class="flex justify-end">
					<Button
						:text="i18n.t('save')"
						:loading="updating"
						@click="atualizarConfiguracoes"
					/>
				</div>
			</div>
		</LayoutConfiguracao>
	</div>
</template>

<script setup>
import { Icon } from '@iconify/vue2'
import Button from '../../../components/ui/button/Button.vue'
import Radio from '../../../components/ui/radio/Radio.vue'
import Tooltip from '../../../components/ui/tooltip/Tooltip.vue'
import { useConfiguracoesAplicativo } from '../../../composables/useConfiguracoesAplicativo'
import LayoutConfiguracao from '../../../layouts/LayoutConfiguracao.vue'
import i18n from '../../../VueI18n'
const { inventario, atualizarConfiguracoes, updating } = useConfiguracoesAplicativo()
</script>

<style></style>
